import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const UNLOCK_CHOICE_AB_TEST_ID = "rp-after-register-choice";
export const UNLOCK_CHOICE_CONTROL_VARIANT = "rp_after_register_choice_2026_09_control" as const;
export const UNLOCK_CHOICE_TREATMENT_VARIANT = "rp_after_register_choice_2026_09_treatment" as const;

/**
 * A/B test managed by Amplitude Experiment. The Amplitude flag must expose `rp_after_register_choice_2026_09_control`
 * and `rp_after_register_choice_2026_09_treatment` variants. The treatment replaces the step that follows unlocking
 * gated content in the registration flow with the unlock choice modal; the control keeps the previous step.
 * Override in dev: ?ab_test_experiment=rp-after-register-choice&ab_test_variant=rp_after_register_choice_2026_09_treatment|rp_after_register_choice_2026_09_control
 */
export const unlockChoiceAbTest: IABTestConfiguration = {
    id: UNLOCK_CHOICE_AB_TEST_ID,
    name: OngoingABTests.UNLOCK_CHOICE,
    expires: new Date(2027, 0, 1),
    path: rpAppPath.base,
    variants: [UNLOCK_CHOICE_CONTROL_VARIANT, UNLOCK_CHOICE_TREATMENT_VARIANT],
    withSSR: false,
    matchOnAllPaths: true,
    useAmplitude: true
};
import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const UNLOCK_CHOICE_AB_TEST_ID = "rp-after-register-choice";
export const UNLOCK_CHOICE_CONTROL_VARIANT = "rp_after_register_choice_2026_09_control" as const;
export const UNLOCK_CHOICE_TREATMENT_VARIANT = "rp_after_register_choice_2026_09_treatment" as const;

/**
 * A/B test managed by Amplitude Experiment. The Amplitude flag must expose `rp_after_register_choice_2026_09_control`
 * and `rp_after_register_choice_2026_09_treatment` variants. The treatment replaces the step that follows unlocking
 * gated content in the registration flow with the unlock choice modal; the control keeps the previous step.
 * Override in dev: ?ab_test_experiment=rp-after-register-choice&ab_test_variant=rp_after_register_choice_2026_09_treatment|rp_after_register_choice_2026_09_control
 */
export const unlockChoiceAbTest: IABTestConfiguration = {
    id: UNLOCK_CHOICE_AB_TEST_ID,
    name: OngoingABTests.UNLOCK_CHOICE,
    expires: new Date(2027, 0, 1),
    path: rpAppPath.base,
    variants: [UNLOCK_CHOICE_CONTROL_VARIANT, UNLOCK_CHOICE_TREATMENT_VARIANT],
    withSSR: false,
    matchOnAllPaths: true,
    useAmplitude: true
};
